import { render, staticRenderFns } from "./PreviewExamDetails.vue?vue&type=template&id=7b4b2d8f&scoped=true"
import script from "./PreviewExamDetails.vue?vue&type=script&lang=js"
export * from "./PreviewExamDetails.vue?vue&type=script&lang=js"
import style0 from "./PreviewExamDetails.vue?vue&type=style&index=0&id=7b4b2d8f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b2d8f",
  null
  
)

export default component.exports